<template>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="pc_code,pc_pjcode,pj_emname"
        placeholder="输入单号、项目名称、项目负责人进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.pc_id"
          :to="'/plm/proj_check/' + item.pc_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.pc_code }}</p>
            <p class="list-item-muted">{{ item.pc_pjcode }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.pj_dename }}&nbsp;{{ item.pj_emname }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.pc_status != '已审核' }"
              >{{ item.pc_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}单</label>
      </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    
    return {
      listUrl: "/api/plm/projcheck/list",
      filters: [
        {
          type: "date",
          name: "plm_proj_check.pc_date",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "pc_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "pc_status='已审核'",
            },
          ],
        },
      ],
    }
  },
};
</script>